import { DataBinning2D } from '../classificators/dataBinning/index.js';
import { ResultData } from '../enums/index.js';
import { BinToCountConverter, BinValueConverterBase } from '../converters/binValueConverters/index.js';
import { ChartSeries, Series } from '../entities/index.js';

const mergeSeries = function(series) {
    return series.reduce((accumulator, current) => accumulator.concat(current), new Series('merged', 2));
};

const binToSeriesMapper = function(bins, sourcesPerBin, binsSourcesMap, binValueConverter){
    return bins.map((binsRow, r) => {
        const rowSeries = new Series(`${binsRow[0].fromWhereY()}`, 3);
        for (let c = 0; c < binsRow.length; c++) {
            const bin = binsRow[c];
            rowSeries.add(
                binsSourcesMap ? binsSourcesMap[r][c]: undefined,
                bin.centerX(), bin.centerY(),
                binValueConverter.getBinValue(bin, sourcesPerBin ? sourcesPerBin[r][c]: [])
            )
        }

        return rowSeries;
    });
};

const matchSourcesToBins = function(bins, results, mergedPoints, mergedSourcesMap) {
    const binsSourcesMap = [];
    const sourcesPerBin = [];

    // no we need to go over bins
    for (let r = 0; r < bins.length; r++) {
        const binRow = bins[r];
        binsSourcesMap[r] = [];
        sourcesPerBin[r] = [];
        
        for (let c = 0; c < binRow.length; c++) {
            const binData = binRow[c].getValues();

            binsSourcesMap[r][c] = [];
            sourcesPerBin[r][c] = [];

            for (let p = 0; p < binData.length; p++) {
                const binPoint = binData[p];
                binsSourcesMap[r][c][p] = [];
                sourcesPerBin[r][c][p] = [];
                
                for (let i = 0; i < mergedPoints.length; i++) {
                    const point = mergedPoints[i];

                    if (typeof(point) === 'undefined') {
                        continue;
                    }

                    if (point[0] === binPoint[0] && point[1] === binPoint[1]){
                        const resultId = mergedSourcesMap[i];
                        binsSourcesMap[r][c][p] = resultId;
                        sourcesPerBin[r][c][p] = results.find(r => r[ResultData.Id.key] === resultId);
                       
                        // removing mergedPoint to speed further iterations
                        delete mergedPoints[i];
                        break;
                    }
                }
            }
        }
    }

    return { binsSourcesMap, sourcesPerBin };
};

const getSeriesForHeatMap = function(
    series, dataBinning, binValueConverter, sources = []
) {
    if (!(series instanceof ChartSeries)) {
        throw new TypeError('series must contain an instance inheriting from ChartSeries');
    }

    if (!(dataBinning instanceof DataBinning2D)) {
        throw new TypeError('dataBinning must be an instance of DataBinning2D');
    }

    let _binValueConverter = null;

    if (typeof(binValueConverter) === 'undefined') {
        _binValueConverter = new BinToCountConverter();
    }
    else if (!(binValueConverter instanceof BinValueConverterBase)) {
        throw new TypeError('binValueConverter must be an instance inheriting from BinValueConverterBase');
    }
    else {
        _binValueConverter = binValueConverter;
    }

    if (!sources instanceof Array) {
        throw new TypeError('sources must contain array or be undefined');
    }

    const mergedPoints = mergeSeries(series);
    const mergedSourcesMap = mergedPoints.getSources();

    const bins = dataBinning.determineBins(mergedPoints.toArray());

    // so now we have bins without reference to the results, we must now re-define resultsMap
    const {binsSourcesMap, sourcesPerBin} = matchSourcesToBins(bins, sources, mergedPoints, mergedSourcesMap);
    
    // now we need to format back to heat map data
    return {
        series: new ChartSeries(
            binToSeriesMapper(bins, sourcesPerBin, binsSourcesMap, _binValueConverter)
        ),
        bins
    };
};

export default getSeriesForHeatMap;